export default __webpack_public_path__ + "static/media/Aura-Egg__82.4a52ef21.png";